import { Modal, SubmitButton } from "@xola/ui-kit";
import { DateFormat } from "common";
import dayjs from "dayjs";
import React from "react";
import { useHistory } from "react-router-dom";
import { useSeller } from "../../../hooks/useAccount";

interface KycRequiredModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const KycRequiredModal = ({ isOpen, onClose }: KycRequiredModalProps) => {
    return (
        <Modal size="huge" isOpen={isOpen} onClose={onClose}>
            <ModalContent onClose={onClose} />
        </Modal>
    );
};

const ModalContent = ({ onClose }: { onClose: () => void }) => {
    const { stripeAccount } = useSeller();
    const history = useHistory();

    const dueDate = stripeAccount.data.verification?.due_by;

    const dueBy = dueDate ? ` by ${dayjs.unix(dueDate).format(DateFormat.DATE_TIME)} ` : " soon ";
    const handleSubmit = () => {
        history?.push("/settings/payments/kycCompleted");
        onClose();
    };

    return (
        <>
            <Modal.Header>KYC Info Required</Modal.Header>

            <Modal.Body>
                We are missing some important KYC information for your bank account. Please update your KYC information
                <var data-var="dueBy">{dueBy}</var> to avoid payout interruptions.
            </Modal.Body>

            <Modal.Footer>
                <SubmitButton onClick={handleSubmit}>Update KYC Information</SubmitButton>
            </Modal.Footer>
        </>
    );
};
